export class ViewLifecycle {
  private disposers: Array<() => void> = [];
  private destroyed = false;

  own(dispose: (() => void) | void): void {
    if (!dispose) return;
    if (this.destroyed) dispose();
    else this.disposers.push(dispose);
  }

  destroy(): void {
    if (this.destroyed) return;
    this.destroyed = true;
    for (const dispose of this.disposers.splice(0).reverse()) dispose();
  }
}
